<!-- NEW DIALOG -->
@if (isDialogVisible) {
  <p-dialog [styleClass]="authService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
    header='{{ vehicleFormTitle | uppercase }}'
    [(visible)]='isDialogVisible'
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
    [modal]='true'
    [draggable]='false'
    [resizable]='false'
    [closeOnEscape]='false'
    [style]="{width: '80vw'}"
    >
<div [ngClass]="{'custom-form-small': authService?.user?.fontSize === 'SMALL', 'custom-form-medium': authService?.user?.fontSize === 'MEDIUM'}">
    <!-- FORM ERRORS -->
    <div #errorContainer>
      @if (errorMessages.length !== 0) {
        <div>
          @for (error of errorMessages; track error) {
            <div>
              <div class='alert alert-warning' role='alert'>{{error}}</div>
            </div>
          }
        </div>
      }
    </div>
    <!-- PANELL HISTORIC DE VEHICLE, sel.leccio de dates -->
    @if (!isNew) {
      <div class='d-flex flex-column gap-3 p-3'>
        <p-panel
          header="{{ 'tableManagement.vehicleHtc.vehicleHtc' | translate }}"
          [ngClass]="isEditingDisabled ? 'disabledPanel' : ''"
          i18n-header>
          <div class='d-flex row-cols-1 w-100'>
            <div class='d-flex'>
              <form-input fieldName="{{ 'tableManagement.vehicleHtc.since' | translate }}" [errors]='' [required]='true' style="margin-right: 20px">
                <p-datepicker [(ngModel)]='startDate'
                  (ngModelChange)='onStartDateChange()'
                  [readonlyInput]='true'
                  [showTime]='false'
                  [style]="{'width':'150px'}"
                  dateFormat='{{i18n.dateFormat}}'
                  showIcon='true'
                  [showOnFocus]='false'
                  appendTo='body'
                ></p-datepicker>
              </form-input>
              <form-input fieldName="{{ 'tableManagement.vehicleHtc.to' | translate }}" [errors]='' [required]='true' style="margin-right: 20px">
                <p-datepicker [(ngModel)]='endDate'
                  (ngModelChange)='onEndDateChange()'
                  [disabled]='startDate === null'
                  [readonlyInput]='true'
                  [showTime]='false'
                  [style]="{'width':'150px'}"
                  dateFormat='{{i18n.dateFormat}}'
                  showIcon='true'
                  [showOnFocus]='false'
                  appendTo='body'
                ></p-datepicker>
              </form-input>
              <form-input [required]='false' fieldName="{{ 'tableManagement.vehicleHtc.period' | translate }}">
                <p-select
                  [options]='historicOptionsList'
                  [(ngModel)]='selectedHistoricOptionsList'
                  dataKey='id'
                  optionLabel='value'
                  [style]="{'width':'250px'}"
                  appendTo='body'
                  (onChange)="onChangePeriod($event)"
                ></p-select>
              </form-input>
              <button
                type='button'
                class='btn custom-button'
                (click)='onSearch()'
                [style]="{'margin-left': '50px'}">
                {{ 'general.search' | translate }}
              </button>
            </div>
          </div>
        </p-panel>
      </div>
    }
    <!-- Pestanyes: Manteniments / ALERTES (boto per desactivar-les totes?) / DOCUMENTACIO / NOTES -->
    <div class='d-flex flex-column gap-3 p-3'>
      <p-tabs value="0" [scrollable]="true">
        <p-tablist>
          <p-tab value="0">{{ 'drivers.table.drivers' | translate }}</p-tab>
          <p-tab value="1">{{ 'vehicleAssignments.header' | translate }}</p-tab>
          <p-tab value="2">{{ 'tableManagement.accessories.accessories' | translate }}</p-tab>
          <p-tab value="3">{{ 'documents.header' | translate }}</p-tab>
          <p-tab value="4">{{ 'tableManagement.fine.fines' | translate }}</p-tab>
          <p-tab value="5">{{ 'tableManagement.tax.taxes' | translate }}</p-tab>
          <p-tab value="6">{{ 'tableManagement.financing.financing' | translate }}</p-tab>
          <p-tab value="7">{{ 'tableManagement.insurances' | translate }}</p-tab>
          <p-tab value="8">{{ 'tableManagement.cardLists.cards' | translate }}</p-tab>
          <p-tab value="9">{{ 'tableManagement.vehicleStatus.vehicleStatus' | translate }}</p-tab>
          <p-tab value="10">{{ 'tableManagement.vehicleUsage.vehicleUsage' | translate }}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
          <p>
            <app-drivers-assignments-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate"
              (refreshDriverAssignment)="refreshDriverAssignments()">
            </app-drivers-assignments-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="1">
          <p>
            <app-vehicle-assignments-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate"
              (refreshVehicleAssignment)="refreshVehicleAssignments()">
            </app-vehicle-assignments-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="2">
          <p>
            <app-inventory-vehicle-accessory-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate">
            </app-inventory-vehicle-accessory-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="3">
          <p>
            <app-doc-table
              [type]="'vehicle'"
              [entity]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate"
              [nested]="true"
            ></app-doc-table>
          </p>
        </p-tabpanel>
          <p-tabpanel value="4">
          <p>
            <app-fine-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate"
              [nested]="true">
            </app-fine-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="5">
            <p>
              <app-taxes-list
                [vehicle]="vehicle"
                [startDate]="startDate"
                [endDate]="endDate">
              </app-taxes-list>
            </p>
          </p-tabpanel>
          <p-tabpanel value="6">
          <p>
            <app-financing-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate">
            </app-financing-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="7">
          <p>
            <app-insurance-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate">
            </app-insurance-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="8">
          <p>
            <app-htc-card-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate">
            </app-htc-card-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="9">
          <p>
            <app-htc-vehicle-status-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate">
            </app-htc-vehicle-status-list>
          </p>
        </p-tabpanel>
          <p-tabpanel value="10">
          <p>
            <app-htc-vehicle-usage-list
              [vehicle]="vehicle"
              [startDate]="startDate"
              [endDate]="endDate">
            </app-htc-vehicle-usage-list>
          </p>
        </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </div>
</p-dialog>
}


